import { OrganizationPermission } from '@/types';

type OrganizationWithPaymentPlan = {
  paymentPlan?: { organizationPermissions?: OrganizationPermission[] } | null;
};

export const organizationHasPermission = (
  organization: OrganizationWithPaymentPlan,
  permission: string
) =>
  !organization.paymentPlan ||
  (organization.paymentPlan.organizationPermissions ?? []).some(
    (organizationPermission) => organizationPermission.name === permission
  );

/**
 * The user's organization permissions (the union across their organizations) narrowed to those
 * the given organization also has. An organization without a payment plan is unrestricted, and
 * until the organization is known only the user's permissions apply.
 */
export const getPermissionsForOrganization = (
  userOrganizationPermissions: string[],
  organization?: OrganizationWithPaymentPlan | null
) => {
  if (!organization?.paymentPlan) {
    return userOrganizationPermissions;
  }
  const organizationPermissions = (organization.paymentPlan.organizationPermissions ?? []).map(
    (permission) => permission.name
  );
  return userOrganizationPermissions.filter((permission) =>
    organizationPermissions.includes(permission)
  );
};
